module.exports = __webpack_public_path__ + "static/media/Menus, Catalogos .1ecd898c.png";